module.exports = __webpack_public_path__ + "media/src/images/partners/kit-dadfafaa349430c302a9adf4946f9a56.jpg";